import { render, staticRenderFns } from "./ProductionBox.vue?vue&type=template&id=6ce244cb&"
import script from "./ProductionBox.vue?vue&type=script&lang=js&"
export * from "./ProductionBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports